<template>
  <svg
    class="icon"
    width="42"
    height="42"
    viewBox="0 0 43 42"
    fill="#bbbbbb"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 0C9.90078 0 0.5 9.40078 0.5 21C0.5 32.5992 9.90078 42 21.5 42C33.0992 42 42.5 32.5992 42.5 21C42.5 9.40078 33.0992 0 21.5 0ZM29.3258 29.7035C27.4227 31.459 24.8223 32.4844 21.7297 32.4844C17.2426 32.4844 13.3625 29.9086 11.4758 26.1598C10.6965 24.6094 10.2535 22.8539 10.2535 21C10.2535 19.1461 10.6965 17.3906 11.4758 15.8402C13.3625 12.0832 17.2426 9.51562 21.7297 9.51562C24.8223 9.51562 27.4227 10.6559 29.416 12.5098L26.1266 15.8074C24.9371 14.6672 23.4195 14.093 21.7379 14.093C18.7437 14.093 16.2172 16.1109 15.3148 18.8262C15.0852 19.5152 14.9539 20.2535 14.9539 21.0082C14.9539 21.7711 15.0852 22.5012 15.3148 23.1902C16.2172 25.9055 18.752 27.9234 21.7379 27.9234C23.2883 27.9234 24.6008 27.5133 25.6262 26.8242C26.8484 26.0121 27.6523 24.798 27.9148 23.3543H21.7379V18.9082H32.5496C32.6891 19.6629 32.7547 20.4422 32.7547 21.2543C32.7465 24.757 31.4996 27.702 29.3258 29.7035Z"
    />
  </svg>
</template>

<style scoped>
.icon {
  transition: fill 0.3s;
}
.icon:hover {
  fill: #13387d;
}
</style>
